import React from 'react';
import { Link } from 'react-router-dom';
import { palletCheckPath } from '../../utils/scanCodes';

/**
 * On the SO page's pallet card (desktop action bar and the phone PalletCard): "Check pallet" (the pallet
 * check screen) and a red "Problem reported" chip while a problem reported there is still open
 * (`openProblems` from usePalletChecks; [] when that call failed, so the chip never shows then). `compact`: the
 * thin size of a card's header row buttons (Prepare shipment's holding pallet cards, 2026-10-29).
 */
export default function PalletCheckLink({ palletId, openProblems = [], phone = false, compact = false }) {
  if (!palletId) return null;
  const n = (openProblems || []).length;
  const latest = n ? openProblems[0] : null;
  const title = latest
    ? `${latest.problem_label || 'Problem'}${latest.checked_by ? `, reported by ${latest.checked_by}` : ''}${n > 1 ? ` (+${n - 1} more)` : ''}`
    : undefined;
  return (
    <>
      <Link to={palletCheckPath(palletId)} className={phone ? 'btn btn-outline-primary' : `btn btn-sm btn-outline-primary${compact ? ' py-0' : ''}`}
        data-testid={`pallet-check-link-${palletId}`}>
        <i className="fas fa-clipboard-check me-1" aria-hidden="true" />Check pallet
      </Link>
      {n > 0 && (
        <span className="badge bg-danger" title={title} data-testid={`pallet-problem-chip-${palletId}`}>
          <i className="fas fa-exclamation-triangle me-1" aria-hidden="true" />Problem reported{n > 1 ? ` (${n})` : ''}
        </span>
      )}
    </>
  );
}
